<template>
  <header-layout>
    <section id="email-validation">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="column">
              <div class="has-text-centered">
                <p>Redirecting...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </header-layout>
</template>

<script>
import Utils from '@/utils/Utils'

import HeaderLayout from '@/layouts/HeaderLayout'

export default {
  components: {
    HeaderLayout
  },

  created () {
    const isValidated = this.$route.query.validate === 'true' || false
    const token = this.$route.query.token

    if (isValidated && token) {
      Utils.setApiToken(token)

      this.$store.dispatch('validateUser')
        .then(res => Utils.setApiToken(res.apitoken, res.user))
        .then(() => this.$router.push(this.$route.params.redirect || 'dashboard'))
    }
  }
}
</script>

<style lang="scss">

#email-validation {
  margin-top: 6rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/EmailValidationPage.vue